import { Component, input, output, ChangeDetectionStrategy} from '@angular/core';
import { AttrPath } from '@cumlaude/metadata';

export interface Groepering {
	naam: string;
	attrPath: AttrPath;
	current: boolean;
}

export interface Categorie {
	naam?: string;
	groeperingen: Groepering[];
}

@Component({
	selector: 'app-groepering-list',
	templateUrl: './groepering-list.component.html',
	styleUrls: ['./groepering-list.component.scss'],
	imports: [],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GroeperingListComponent {
	groeperingCategorieen = input.required<Categorie[]>();

	selected = output<Groepering>();

	select(groepering: Groepering) {
		this.selected.emit(groepering);
	}
}
